import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=2fee5988&scoped=true&"
import script from "./teachers.vue?vue&type=script&lang=ts&"
export * from "./teachers.vue?vue&type=script&lang=ts&"
import style0 from "./teachers.vue?vue&type=style&index=0&id=2fee5988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee5988",
  null
  
)

export default component.exports